import React, { useContext, useMemo } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import {
  COLLEAGUE_ID,
  DEAL_STATUS_FILTER_KEY,
  ENTERPRISE_BUSINESS_UNIT,
} from '../../../../../Portfolio/components/PortfolioSellerFilters/data';
import EnterpriseContext from '../../../../providers/Enterprise/Enterprise.context';
import { isSingleElementArray } from 'utils';
import useCreateSelectOptions from 'hooks/useCreateSelectOptions';
import { TIMEFRAME } from 'models/EnterprisesAnalytics';
import { FilterOption } from 'models/Filters';
import { INDUSTRY_FILTER_KEY } from 'router/subrouters/Dash/subrouters/Business/pages/Businesses/components/filters/IndustryFilter/IndustryFilter.component';
import { DEAL_STAGE } from 'models/DealRoom';
import { PER_PAGE } from 'components/NumberOfResultsPerPageFilter/NumberOfResultsPerPageFilter.component';
import { LIMIT_PARAM_KEYWORD, TIMEFRAME_PARAM_KEYWORD } from 'data/global';
import { DEAL_STATUS_LABEL } from 'data/dealStatus';
import useOperationStepValues from 'router/data/useOperationStepValues';
import MultiFilter from 'components/MultiFilter';

import './AnalyticsFitlers.styles.scss';

type AnalyticsFitlersProps = {
  className?: string;
};

const AnalyticsFitlers: React.FC<AnalyticsFitlersProps> = (props) => {
  const { className } = props;

  const { units, brokers } = useContext(EnterpriseContext);

  const classes = classNames('analytics-fitlers', className);

  const { industrySelectOptions } = useOperationStepValues();

  const createSelectOptions = useCreateSelectOptions();

  const { t } = useTranslation();

  const filterOptions = useMemo(
    () =>
      [
        {
          value: TIMEFRAME_PARAM_KEYWORD,
          label: t('createdDuring'),
          shouldSortOptions: false,
          options: createSelectOptions(Object.values(TIMEFRAME)),
        },
        ...(!isSingleElementArray(units)
          ? [
              {
                value: ENTERPRISE_BUSINESS_UNIT,
                label: t('businessUnit'),
                isMultiple: true,
                options: units,
              },
            ]
          : []),
        {
          value: COLLEAGUE_ID,
          label: t('broker'),
          options: brokers,
        },
        {
          value: INDUSTRY_FILTER_KEY,
          label: t('industry'),
          isMultiple: true,
          options: industrySelectOptions,
        },
        {
          value: DEAL_STATUS_FILTER_KEY,
          label: t('stage'),
          options: Object.values(DEAL_STAGE).map((value) => ({
            value,
            label: t(DEAL_STATUS_LABEL[value]),
          })),
        },
        {
          value: LIMIT_PARAM_KEYWORD,
          shouldSortOptions: false,
          label: t('limit'),
          options: createSelectOptions(PER_PAGE),
        },
      ] as FilterOption[],
    [units, brokers, industrySelectOptions, createSelectOptions, t],
  );

  return <MultiFilter className={classes} filterOptions={filterOptions} />;
};

export default AnalyticsFitlers;
